import axios from 'axios'

export default {
    get: () => axios.get('certificates'),
    store: (data) => axios.post('certificates/store', data),
    delete: (id) => axios.delete('certificates/'+id),
    excel: () => axios.post('certificates/excel')
}